import { forwardRef } from 'react';
import { FormBuilder } from '@/formbuilder/FormBuilder.page';
import type { FunctionComponent } from 'react';
import type { FormBuilderProps } from '@/formbuilder/FormBuilder.page';

type SaveAndContinueFormBuilderProps = FormBuilderProps & {
  extraClassNames?: string;
};

/**
 * SaveAndContinueFormBuilder generates forms based on the provided form definition Array and supports a "Wizard"
 * like user experience.
 * In addition to a Save and Cancel button, this component also includes a Continue button that when clicked submits
 * that form but does not close it.
 **/
// eslint-disable-next-line @typescript-eslint/ban-types
export const SaveAndContinueFormBuilder: FunctionComponent<SaveAndContinueFormBuilderProps> = forwardRef(
  function SaveAndContinueFormBuilder(props, ref) {
    return <FormBuilder {...props} ref={ref} saveAndCancel={true} extraClassNamesUnwrapped={props.extraClassNames} />;
  },
);
